import { useGetHealthData } from '../../../use-health-data';
import { LastUpdatedTagSkeleton } from './last-updated-tag-skeleton';

export function LastUpdatedTag() {
  const { healthData, isInitiallyFetching } = useGetHealthData();
  const lastUpdatedDate = healthData?.metadata?.lastUpdated;

  if (isInitiallyFetching) {
    return <LastUpdatedTagSkeleton />;
  }

  if (!lastUpdatedDate) {
    return null;
  }

  return (
    <div className="flex justify-center">
      <div className="rounded-full bg-white/10 px-3 py-0.5">
        <span className="text-xs font-bold text-white">Last Updated {lastUpdatedDate}</span>
      </div>
    </div>
  );
}
